import React, { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { changePassword } from '../services/api'; // Adjust the import path as needed

const ChangePassword = ({ setPasswordChangeRequired }) => {
  const [oldPassword, setOldPassword] = useState('');
  const [newPassword, setNewPassword] = useState('');
  const [userId, setUserId] = useState('');
  const navigate = useNavigate();

  useEffect(() => {
    const storedUserId = localStorage.getItem("userId");
    const storedUserRole = localStorage.getItem("userRole");
    console.log('User ID:', storedUserId);
    console.log('User Role:', storedUserRole);
    if (storedUserId) {
      setUserId(storedUserId);
    }
  }, []);

  const handleChangePassword = async (e) => {
    e.preventDefault();
    try {
      const response = await changePassword(userId, oldPassword, newPassword);
      if (response.status === 200) {
        alert('Password changed successfully!');
        setPasswordChangeRequired(false);
        // Redirect to the appropriate dashboard based on user role
        const userRole = localStorage.getItem("userRole");
        console.log('userRole in change password:', userRole);
        if (userRole === 'PRIMARY' || userRole === 'SECONDARY') {
          navigate('/ownerdashboard');
        } else if (userRole === 'AGENT') {
          navigate('/agentdashboard');
        } else {
          navigate('/');
        }
      }
    } catch (error) {
      alert('Failed to change password. Please try again.');
    }
  };

  return (
    <div className="container">
      <h2>Change Password</h2>
      <form onSubmit={handleChangePassword}>
        <input
          type="password"
          placeholder="Old Password"
          value={oldPassword}
          onChange={(e) => setOldPassword(e.target.value)}
        />
        <br />
        <input
          type="password"
          placeholder="New Password"
          value={newPassword}
          onChange={(e) => setNewPassword(e.target.value)}
        />
        <br />
        <button type="submit">Change Password</button>
      </form>
    </div>
  );
};

export default ChangePassword;